/* Cuadra Piedreros — Nudge "Elige tu gorra gratis" (regalo por escalón)
 * Picker: el cliente escoge 1 gorra de las que desbloqueó su gasto y la agrega.
 * Un solo listener delegado en document (sobrevive re-renders del carrito).
 * El markup + la lógica mostrar/ocultar vive en snippets/cap-nudge.liquid (Liquid puro).
 * El descuento de Kite pone la gorra en $0; aquí solo se agrega la variante elegida.
 */
(function () {
  'use strict';
  if (window.__cpCapNudge) return;
  window.__cpCapNudge = true;

  // Habilitar/deshabilitar el botón "Agregar" según haya selección.
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('.cp-cap-opt__radio');
    if (!radio) return;
    var wrap = radio.closest('[data-cap-nudge]');
    if (!wrap) return;
    var btn = wrap.querySelector('[data-cp-cap-add]');
    if (btn) btn.disabled = false;
  });

  // Looney Tunes: al cambiar el personaje, cambia la miniatura, marca su radio y
  // habilita el botón (así elegir en el dropdown ya cuenta como selección).
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-cap-variant-select]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var optWrap = sel.closest('.cp-cap-opt');
    if (opt && opt.dataset.img && optWrap) {
      var img = optWrap.querySelector('[data-cap-looney-img]');
      if (img) img.src = opt.dataset.img;
    }
    var radio = optWrap ? optWrap.querySelector('.cp-cap-opt__radio') : null;
    if (radio) radio.checked = true;
    var wrap = sel.closest('[data-cap-nudge]');
    var btn = wrap ? wrap.querySelector('[data-cp-cap-add]') : null;
    if (btn) btn.disabled = false;
  });

  function chosenVariant(wrap) {
    var radio = wrap.querySelector('.cp-cap-opt__radio:checked');
    if (!radio) return null;
    // Opción Looney Tunes: la variante sale del <select> dentro de esa opción.
    if (radio.hasAttribute('data-variant-select')) {
      var sel = radio.closest('.cp-cap-opt').querySelector('[data-cap-variant-select]');
      return sel ? sel.value : null;
    }
    return radio.getAttribute('data-variant');
  }

  async function addVariant(id) {
    if (!id || id === '0') return false;
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      return res.ok;
    } catch (e) {
      return false;
    }
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-cp-cap-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.dataset.busy) return;

    var wrap = btn.closest('[data-cap-nudge]');
    var id = wrap ? chosenVariant(wrap) : null;
    if (!id) return;

    btn.dataset.busy = '1';
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Agregando…';

    var ok = await addVariant(id);

    if (ok) {
      btn.textContent = '✓ ¡Gorra agregada!';
      // Recargar mantiene todo consistente: la gorra entra en $0 y el nudge desaparece solo.
      setTimeout(function () { window.location.reload(); }, 500);
    } else {
      btn.textContent = 'Se agotó — inténtalo de nuevo';
      delete btn.dataset.busy;
      setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2500);
    }
  });
})();
